import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import { AbActionMenuItem } from "abreact/incubator/ui/component/actionBar/AbActionMenuItem";
import { action, observable, makeObservable } from "mobx";
export let AbAsyncActionMenuItem = (_class = class AbAsyncActionMenuItem extends AbActionMenuItem {
  constructor(icon, label, callback, enabled = true, shortcut = null, dataTestId) {
    super(icon, label, async target => {
      if (callback) {
        try {
          this.setBusy(true);
          await callback(target);
        } finally {
          this.setBusy(false);
        }
      }
    }, enabled, shortcut, dataTestId);
    _initializerDefineProperty(this, "_isBusy", _descriptor, this);
    makeObservable(this);
    this._isBusy = undefined;
  }
  get isBusy() {
    return this._isBusy;
  }
  setBusy(value) {
    this._isBusy = value;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_isBusy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setBusy", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setBusy"), _class.prototype), _class);
//# sourceMappingURL=AbAsyncActionMenuItem.js.map
